var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.detailLayout != '')?_c('event-detail-link',{attrs:{"detailLayout":_vm.detailLayout,"eventData":_vm.eventData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }